/* eslint-disable array-callback-return */
import SelectInput from '../../Common/ui/selectInput'
import Input from '../../Common/ui/input'
import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'

const QuantitativeRiskAssessment = ({ AllFormData, setAllFormData }) => {
    const [ riskEvents, setRiskEvents ] = useState([])
    const [ riskJustifications, setRiskJustifications ] = useState([])
    const { t } = useTranslation()

    const { register, formState: { errors }, control } = useForm()

    const onValueChange = (e) => {
        const { name, value } = e.target
        setAllFormData(({
            ...AllFormData,
            quantitativeRiskAssessment: {
                ...AllFormData?.quantitativeRiskAssessment,
                [name]: value
            }
        }))
    }
    const onValueSelectChange = (name, value) => {
        setAllFormData(({
            ...AllFormData,
            quantitativeRiskAssessment: {
                ...AllFormData?.quantitativeRiskAssessment,
                [name]: value
            }
        }))
    }
    const instance = Axios.getInstance()

    const getAllRiskEvents = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllRiskEvents')
            return response.data
        } catch (error) {
            console.error('Error fetching risk events:', error)
            throw error
        }
    }
    const getAllRiskJustifications = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllRiskJustifications')
            return response.data
        } catch (error) {
            console.error('Error fetching risk justifications:', error)
            throw error
        }
    }

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllRiskEvents()
                setRiskEvents(types)
            } catch (error) {
                console.error('Error fetching risk events:', error)
            }
            try {
                const types = await getAllRiskJustifications()
                setRiskJustifications(types)
            } catch (error) {
                console.error('Error fetching all justification:', error)
            }
        }
        fetchRiskTypes()
    }, [])

    // useEffect(() => {
    //     if (AllFormData?.quantitativeRiskAssessment?.sleValue && AllFormData?.quantitativeRiskAssessment?.aro) {
    //         setAllFormData({
    //             ...AllFormData,
    //             quantitativeRiskAssessment: {
    //                 ...AllFormData?.QuantitativeRiskAssessment,
    //                 aleValue: AllFormData?.quantitativeRiskAssessment?.aro * AllFormData?.quantitativeRiskAssessment?.sleValue
    //             }
    //         })
    //     }
    // }, [ AllFormData?.quantitativeRiskAssessment?.sleValue, AllFormData?.quantitativeRiskAssessment?.aro ])

    return (
        <Typography>
            <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Mitigation Plan')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <SelectInput
                        label={t('Event')}
                        required
                        rules={{ required: 'This field is Required' }}
                        control={control}
                        errors={errors}
                        name="event"
                        placeholder="Select Event"
                        onValueChange={(value) => onValueSelectChange('event', value)}
                        value={AllFormData?.quantitativeRiskAssessment?.event ? riskEvents?.find((dt) => dt.name === AllFormData?.quantitativeRiskAssessment?.event)?.id : ''}
                        options={riskEvents.map(type => ({ value: type.id, label: type.name }))}/>
                </Box>
                <Box gridColumn="span 6">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='eventDescription'
                        label={t('Description')}
                        register={register}
                        placeholder="Enter Description"
                        type="text"
                        value={AllFormData?.quantitativeRiskAssessment?.eventDescription}
                        onValueChange={onValueChange}
                    />
                </Box>
            </Box>
            <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Single & Annual Loss Expectancy')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='sleValue'
                        label={t('SLE Value')}
                        register={register}
                        placeholder="Enter SLE Value"
                        type="number"
                        value={AllFormData?.quantitativeRiskAssessment?.sleValue}
                        onValueChange={onValueChange}
                    />
                </Box>
                <Box gridColumn="span 3">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='aro'
                        label={t('Annual Rate of Occurrence (ARO)')}
                        register={register}
                        placeholder="Enter Annual Rate of Occurrence (ARO)"
                        type="number"
                        value={AllFormData?.quantitativeRiskAssessment?.aro}
                        onValueChange={onValueChange}
                    />
                </Box>
                <Box gridColumn="span 3">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='aleValue'
                        label={t('ALE Value')}
                        register={register}
                        placeholder="Enter ALE Value"
                        type="text"
                        readOnly={true}
                        value={AllFormData?.quantitativeRiskAssessment?.aro * AllFormData?.quantitativeRiskAssessment?.sleValue}
                        // onValueChange={onValueChange}
                    />
                </Box>
            </Box>
            <Box sx={{ p: 4, display: 'flex', width: '50%', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Justification')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <SelectInput
                        label={t('Justification')}
                        required
                        rules={{ required: 'This field is Required' }}
                        control={control}
                        errors={errors}
                        name="justification"
                        placeholder="Select Justification"
                        onValueChange={(value) => onValueSelectChange('justification', value)}
                        value={AllFormData?.quantitativeRiskAssessment?.justification ? riskJustifications?.find((dt) => dt.name === AllFormData?.quantitativeRiskAssessment?.justification)?.id : ''}
                        options={riskJustifications.map(type => ({ value: type.id, label: type.name }))}/>
                </Box>
                <Box gridColumn="span 6">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='justificationDescription'
                        label={t('Justification Description')}
                        register={register}
                        placeholder="Enter Justification Description"
                        type="text"
                        value={AllFormData?.quantitativeRiskAssessment?.justificationDescription}
                        onValueChange={onValueChange}
                    />
                </Box>
                <Box gridColumn="span 9">
                    <Input
                        errors={errors}
                        control={control}
                        required
                        rules={{ required: 'This field is Required' }}
                        name='qraImpact'
                        label={t('Impact of the QRA')}
                        register={register}
                        placeholder="Enter Impact of the QRA"
                        type="text"
                        value={AllFormData?.quantitativeRiskAssessment?.qraImpact}
                        onValueChange={onValueChange}
                    />
                </Box>
            </Box>
        </Typography>
    )
}

export default QuantitativeRiskAssessment
